import React, { Component } from 'react';
import { Grid } from 'semantic-ui-react';
import SideNavComponent from './SideNav';
import { GlobalContext } from '../global-context';
import { ERRORSTYLE, APIREADY, APIMAINTENANCE, APIUNCONFIGURED } from "../util/constants";

console.log("Version", 14)

export default class App extends Component {
  static contextType = GlobalContext;

  navigate = (destination) => {
    this.props.history.push(`/${destination}`)
  }

  componentDidMount() {
    const { setGlobalError, setAppMode } = this.context;
    this.interval = setInterval(async () => {
      const { appMode } = this.context;
      var message;
      try {
        const res = await fetch("/api/ping");
        if (!res || !res.ok) {
          try {
            const errdata = await res.json();
            message = `error ${res.status} during API "ping": ${errdata.message}`;
          } catch(error) {
            message = `unknown error contacting backend API; try reloading the page?`;
          }
        } else { // normal response
          const apistate = await res.json();
          if (apistate !== APIREADY) {
            setAppMode(apistate)
          } else {
            appMode && setAppMode(apistate)
          }
        }
      } catch(error) {
        // ping failed entirely, can't reach front-end server, most likely
        // user needs to log in to netbadge again
        message = "Application unreachable, reload page to log-in"
      }
      if (message && message !== this.oldmsg) {
        console.log(message);
        this.oldmsg = message
      }
      if (message) {
        setGlobalError(message);
      }
    }, 3000);
  }

  componentWillUnmount(){
    clearInterval(this.interval);
  }

  render() {
    const children = React.Children.map(this.props.children, child => {
      return React.cloneElement(child, {
        navigate: this.navigate,
      });
    });
    const { appMode, globalError, errStamp } = this.context;
    const now = Math.floor(new Date().getTime()/1000);
    let errMessage = null;
    if (globalError && now - errStamp < 5) {
      errMessage = globalError;
    }
    let appState = null
    if (appMode) {
      let message = "Application updated, reload page to continue..."
      if (appMode === APIMAINTENANCE || appMode === APIUNCONFIGURED) {
        message = "Application undergoing maintenance, please check back later..."
      }
      appState = <h1>{message}</h1>
    }
    return (
      <Grid columns='equal'>
        <Grid.Column width={4}>
          <SideNavComponent navigate={this.navigate}/>
        </Grid.Column>
        <Grid.Column>
          {errMessage && <div style={ERRORSTYLE}>{errMessage}</div>}
          {appState ? appState : children}
        </Grid.Column>
      </Grid>
    );
  }
}
